"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

///<reference path="../api.d.ts" />
///<reference path="../../../shared/address/address-controller.ts" />
var agencyRegistration;
(function (agencyRegistration) {
    var controller;
    (function (controller) {
        var AssociateController = function () {
            /*@ngInject*/

            function AssociateController($rootScope, $state, agentFactory, createService, $mdDialog) {
                var _this = this;

                _classCallCheck(this, AssociateController);

                this.loader = new common.Loader();
                // Dependencies
                this.createService = createService;
                this.$mdDialog = $mdDialog;
                this.stateService = $state;
                this.$rootScope = $rootScope;
                this.agentFactory = agentFactory;
                // Properties
                this.agency = agentFactory.getAgency();
                this.alert = new common.AlertMessage($mdDialog);
                // Get Fields
                createService.getFields().then(function (fields) {
                    _this.fieldOptions = fields;
                });
            }

            _createClass(AssociateController, [{
                key: "showLoaders",
                value: function showLoaders() {
                    this.$rootScope.$createLoader.showLoader("Salvando dados da agência...");
                    this.loader.showLoader("Salvando dados da agência...");
                }
            }, {
                key: "hideLoaders",
                value: function hideLoaders() {
                    this.$rootScope.$createLoader.hide();
                    this.loader.hide();
                }
            }, {
                key: "cancel",
                value: function cancel() {
                    this.agentFactory.setNewAgency();
                    this.stateService.go("search");
                }
            }, {
                key: "saveAgent",
                value: function saveAgent(form, agency) {
                    var _this2 = this;

                    form.$submitted = true;
                    if (form.$valid) {
                        this.showLoaders();
                        // Loader Test
                        setTimeout(function () {
                            _this2.createService.createAgency(agency).then(function (response) {
                                if (response["agencyPersonCode"]) {
                                    _this2.stateService.go("success", { agency: _this2.agency });
                                } else {
                                    _this2.alert.show({ content: response["error"]["message"] });
                                }
                            }).finally(function () {
                                _this2.hideLoaders();
                            });
                        }, 1500);
                    }
                }
            }, {
                key: "addPartnerItem",
                value: function addPartnerItem() {
                    if (this.agency.partners.length < 5) this.agency.partners.push({ personType: 'F' });
                }
            }, {
                key: "removePartnerItem",
                value: function removePartnerItem(item) {
                    var index = this.agency.partners.indexOf(item);
                    this.agency.partners.splice(index, 1);
                }
            }]);

            return AssociateController;
        }();

        controller.AssociateController = AssociateController;
    })(controller = agencyRegistration.controller || (agencyRegistration.controller = {}));
})(agencyRegistration || (agencyRegistration = {}));
angular.module('agencyRegistrationApp').controller('AssociateController', agencyRegistration.controller.AssociateController);